module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?53f53f50a1b2033979f58d724a02a7e5";